import { render } from "./Transform.vue?vue&type=template&id=3a5a9824"
import script from "./Transform.vue?vue&type=script&lang=js"
export * from "./Transform.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__